export default "images/限速提示-限速100.png";